const menu = [
  {
    name: 'eCommerce',
    link: '#',
    position: [340, 280],
    size: 2.1,
    sub: [
      {
        name: 'FMCG',
        color: 0x006edc,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.7,
        position: [-130, 100],
      },
      {
        name: 'Architecture',
        color: 0x00a0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 1.5,
        position: [200, -50],
      },
      {
        name: 'Insurance',
        color: 0xb4f0ff,
        fontColor: 0x000000,
        fill: true,
        link: '#',
        size: 0.6,
        position: [50, 140],
      },
      {
        name: 'Internet',
        color: 0x003c78,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.8,
        position: [40, -140],
      },
      {
        name: 'Healthcare',
        color: 0xb4f0ff,
        fontColor: 0x000000,
        fill: true,
        link: '#',
        size: 1,
        position: [140, -160],
      },
      {
        name: 'Entertainment',
        color: 0x55c8fa,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.6,
        position: [120, 100],
      },
      {
        name: '',
        color: 0x55c8fa,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.5,
        position: [260, 20],
      },
      {
        name: '',
        color: 0x006edc,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.5,
        position: [100, -100],
      },
      {
        name: '',
        color: 0x00a0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.7,
        position: [-10, 160],
      },
    ],
  },
  {
    name: 'Enterprise\nSolution\n(ERP/POS)',
    link: '#',
    position: [250, 700],
    size: 1.5,
    sub: [
      {
        name: 'FMCG',
        color: 0x003C78,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.4,
        position: [80, 120],
      },
      {
        name: 'Internet',
        color: 0x00A0FF,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 1.0,
        position: [150, 0],
      },
      {
        name: '',
        color: 0xb4f0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.6,
        position: [120, -10],
      },
      {
        name: '',
        color: 0xb4f0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.3,
        position: [190, -40],
      },
      {
        name: '',
        color: 0x55c8fa,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.3,
        position: [20, 100],
      },
      {
        name: '',
        color: 0x003c78,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 1,
        position: [-170, -50],
      },
      {
        name: '',
        color: 0x55c8fa,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 1.5,
        position: [-130, -100],
      },
      {
        name: '',
        color: 0x003c78,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.4,
        position: [130, -130],
      },
    ],
  },
  {
    name: 'MarTech',
    link: '#',
    position: [800, 650],
    size: 1.5,
    sub: [
      {
        name: 'Finance',
        color: 0xb4f0ff,
        fontColor: 0x000000,
        fill: true,
        link: '#',
        size: 1.3,
        position: [120, -90],
      },
      {
        name: 'Internet',
        color: 0x55c8fa,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 1.5,
        position: [100, 100],
      },
      {
        name: 'FMCG',
        color: 0x003c78,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 1,
        position: [-120, 0],
      },
      {
        name: '',
        color: 0x003c78,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.7,
        position: [120, 0],
      },
      {
        name: '',
        color: 0xb4f0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.6,
        position: [-50, 120],
      },
      {
        name: '',
        color: 0x00a0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.8,
        position: [-140, -100],
      },
      {
        name: '',
        color: 0xb4f0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.6,
        position: [-160, -80],
      },
    ],
  },
  {
    name: 'Data\nAnalytics',
    link: '#',
    position: [1250, 550],
    size: 1.5,
    sub: [
      {
        name: 'Healthcare',
        color: 0x55c8fa,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 1.5,
        position: [140, 60],
      },
      {
        name: 'Internet',
        color: 0x55c8fa,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 1.5,
        position: [-130, 50],
      },
      {
        name: '',
        color: 0x003c78,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.7,
        position: [-70, 100],
      },
      {
        name: '',
        color: 0xb4f0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.3,
        position: [-110, 110],
      },
      {
        name: '',
        color: 0x00a0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.3,
        position: [-150, 80],
      },
      {
        name: '',
        color: 0x003c78,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.7,
        position: [80, -80],
      },
      {
        name: '',
        color: 0xb4f0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.3,
        position: [50, -120],
      },
    ],
  },
  {
    name: 'Web',
    link: '#',
    position: [1600, 250],
    size: 1.8,
    sub: [
      // {
      //   name: 'Industrial',
      //   color: 0x003c78,
      //   fontColor: 0xffffff,
      //   fill: true,
      //   link: '#',
      //   size: 1.5,
      //   position: [-150, 30],
      // },
      {
        name: 'Entertainment',
        color: 0x55c8fa,
        fontColor: 0xffffff,
        fill: true,
        size: 1.7,
        position: [-180, -80],
      },
      {
        name: 'Architecture',
        color: 0xb4f0ff,
        fontColor: 0x000000,
        fill: true,
        link: '#',
        size: 1.9,
        position: [100, -160],
      },
      {
        name: 'FMCG',
        color: 0xb4f0ff,
        fontColor: 0x000000,
        fill: true,
        size: 1.5,
        position: [180, 50],
      },
      {
        name: 'Finance',
        color: 0x003c78,
        fontColor: 0xffffff,
        fill: true,
        size: 0.7,
        position: [200, 0],
      },
      {
        name: '',
        color: 0x003c78,
        fontColor: 0xffffff,
        fill: true,
        size: 0.8,
        position: [220, 100],
      },
      {
        name: 'Internet',
        color: 0x00a0ff,
        fontColor: 0xffffff,
        fill: true,
        size: 0.7,
        position: [50, 120],
      },
      {
        name: '',
        color: 0xb4f0ff,
        fontColor: 0x000000,
        fill: true,
        size: 0.5,
        position: [-30, 150],
      },
    ],
  },
  {
    name: 'APP',
    link: '#',
    position: [1700, 750],
    size: 1.5,
    sub: [
      {
        name: 'Entertainment',
        color: 0x00a0ff,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.8,
        position: [-120, 60],
      },
      {
        name: '',
        color: 0x003c78,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.6,
        position: [-100, 90],
      },
      {
        name: 'Internet',
        color: 0x55c8fa,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 0.7,
        position: [-40, 100],
      },
      {
        name: 'FMCG',
        color: 0xb4f0ff,
        fontColor: 0x000000,
        fill: true,
        link: '#',
        size: 1,
        position: [-50, -120],
      },
      {
        name: '',
        color: 0xb4f0ff,
        fontColor: 0x000000,
        fill: true,
        link: '#',
        size: 0.7,
        position: [115, 40],
      },
      {
        name: '',
        color: 0x006edc,
        fontColor: 0x000000,
        fill: true,
        link: '#',
        size: 0.5,
        position: [80, -100],
      },
      {
        name: 'Finance',
        color: 0x55c8fa,
        fontColor: 0xffffff,
        fill: true,
        link: '#',
        size: 1.5,
        position: [150, -40],
      },
      {
        name: '',
        color: 0x00a0ff,
        fontColor: 0x000000,
        fill: true,
        link: '#',
        size: 0.4,
        position: [120, -10],
      },
    ],
  },
];

window.menu = menu;
